'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/Teams';
const INIT_STATE = {
  teams: [],
  requestState: RequestState.NOT_REQUESTED
};
export function teams(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_TEAMS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_TEAMS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_TEAMS:
      return Object.assign({}, state, {
        teams: action.teams
      });
    case Actions.FAILED_GETTING_TEAMS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}